/**
 * SearchContent component.
 */
import Container from '@components/atoms/container/searchContentContainer';
import DefaultRail from '@components/sections/rails/ui/rails/defaultRail';
import Direction from '@shared/types/enums/direction';
import FocusUtils from '@shared/utils/focus';
import Focus from '@shared/types/enums/focus';
import MainContext from '@shared/components/utils/context/mainContext';
import VerticalAnimationContainer from '@components/atoms/container/verticalAnimationContainer';
import useTransform from '@shared/components/utils/hooks/useTransform';
import { TRANSITION } from '@shared/types/constants/animations';
import { selectFocus } from '@shared/store/slices/focus.slice';
import { useAppSelector } from '@shared/store/hooks';
import { useContext, useEffect, useState } from 'react';

/**
 * Constants.
 *
 * @constant {number} OFFSET - Vertical offset for the search content.
 */
const OFFSET = 350;

/**
 * SearchContent component.
 *
 * @param {Rail[]} rails - The rails to display.
 * @returns {React.ReactNode} The SearchContent component.
 */
export default function SearchContent() {
  const { rails } = useContext(MainContext);
  const focus = useAppSelector(selectFocus);
  const [transition, setTransition] = useState<string>(
    TRANSITION.SEARCH_RAILS_SCROLL_DOWN
  );
  const [style, , , changeStyle] = useTransform(0, OFFSET, Direction.VERTICAL);

  useEffect(() => {
    if (
      FocusUtils.evaluateFocus(Focus.RAILS_LIST) ||
      focus === Focus.MODAL_INPUT ||
      focus === Focus.FLOATING_MENU
    ) {
      setTransition(TRANSITION.SEARCH_RAILS_SCROLL_DOWN);
      setTimeout(() => {
        changeStyle(0);
      });
    } else {
      setTransition(TRANSITION.SEARCH_RAILS_SCROLL_UP);
      setTimeout(() => {
        changeStyle(1);
      });
    }
  }, [focus]);

  return rails?.length ? (
    <VerticalAnimationContainer transition={transition} style={style}>
      <Container>
        {rails?.map((rail) => (
          <DefaultRail key={rail.id} rail={rail} />
        ))}
      </Container>
    </VerticalAnimationContainer>
  ) : null;
}
